import axios from 'axios'
import i18n from '@/plugins/i18n'

export default {
  // Получение данных для страницы "Норматив пользования"
  getUsageStandarFilterFormData () {
    return axios.get(`${i18n.locale}/api/fauna_limit/getFilterFormData`)
  },
  // Получение данных по году
  getUsageStandardList (year) {
    return axios.get(`${i18n.locale}/api/fauna_limit/getList/${year}`)
  },
  // Получение данных для просмотра
  getInfo (id) {
    return axios.get(`${i18n.locale}/api/fauna_limit/getInfo/${id}`)
  },
  // Редактирование
  edit (id, data) {
    return axios.post(`${i18n.locale}/api/fauna_limit/edit/${id}`, data)
  },
  // Получение данных для страницы создания
  getFaunaLimitFormData () {
    return axios.get(`${i18n.locale}/api/fauna_limit/getFaunaLimitFormData`)
  },
  // Создание
  createFaunaLimit (data) {
    return axios.post(`${i18n.locale}/api/fauna_limit/createFaunaLimit`, data)
  }
}
